import React, { useRef } from "react";
import { Tooltip } from "../Tooltip/Tooltip";
import {
    isOverflowingX,
    isOverflowingY,
    useTruncationTooltip,
} from "../Tooltip/useTruncationTooltip";

interface Props<T extends HTMLElement = HTMLElement> {
    readonly fullText: string;
    readonly overflowDirection: "vertical" | "horizontal";
    readonly children: (ref: React.RefObject<T | null>) => React.ReactElement;
}

/** @deprecated Use @design-system/BreakableText/BreakableText. EllipsisWithTooltip is deprecated. */
export const EllipsisWithTooltip = <T extends HTMLElement = HTMLElement>({
    fullText,
    overflowDirection,
    children,
}: Props<T>) => {
    const ref = useRef<T>(null);
    const truncationTooltipProps = useTruncationTooltip({
        ref,
        isTruncated:
            overflowDirection === "vertical" ? isOverflowingY : isOverflowingX,
    });

    return (
        <Tooltip content={fullText} {...truncationTooltipProps}>
            {children(ref)}
        </Tooltip>
    );
};
